module.exports = __webpack_public_path__ + "static/media/arrow-head-to-the-right.e7316f9a.png";